const initialState = {
  resultsParticipantsCategoriesList: [],
  resultsParticipantsCategory: {},
  resultsParticipantsCategoryAdd: {},
  updateParticipantsCategory: {},
  resultsParticipantsCategoryDelete: {},
  loading: false,
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    // Actions that start loading
    case "GET_LIST_PARTICIPANTS_CATEGORY":
    case "CREATE_PARTICIPANTS_CATEGORY":
    case "UPDATE_PARTICIPANTS_CATEGORY":
    case "DELETE_PARTICIPANTS_CATEGORY":
      newState.loading = true;
      break;

    // Actions that stop loading & handle data
    case "RESPONSE_GET_PARTICIPANTS_CATEGORY":
      newState.resultsParticipantsCategoriesList = action.value;
      newState.loading = false;
      break;
    case "RESPONSE_UPDATE_PARTICIPANTS_CATEGORY":
      newState.updateParticipantsCategory = action.value;
      newState.loading = false;
      break;
    case "RESPONSE_CREATE_PARTICIPANTS_CATEGORY":
      newState.resultsParticipantsCategoryAdd = action.value;
      newState.loading = false;
      break;
    case "RESPONSE_DELETE_PARTICIPANTS_CATEGORY":
      newState.resultsParticipantsCategoryDelete = action.value;
      newState.loading = false;
      break;
    case "RESET_PARTICIPANTS_CATEGORY_RESPONSES":
      newState.resultsParticipantsCategoryAdd = {};
      newState.updateParticipantsCategory = {};
      newState.resultsParticipantsCategoryDelete = {};
      newState.resultsParticipantsCategoriesList = [];
      break;
    default:
      break;
  }
  return newState;
}

export default reducer;
